module.exports = __webpack_public_path__ + "static/media/washington-dc.6c25a109.svg";